import { Helmet } from "react-helmet-async";
import DOMPurify from "dompurify";
import MainLayout from "@/layouts/MainLayout";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import PointedSectionBackground from "@/components/PointedSectionBackground";

const ReturnPolicy = () => {
  const { settings } = useSiteSettings();

  const title = settings.returns_hero_title || "Return Policy";
  const subtitle =
    settings.returns_hero_subtitle || "How orders, cancellations, and refunds work through our printing partner";
  const content = settings.returns_content || "";

  return (
    <MainLayout>
      <Helmet>
        <title>Return Policy | Rogue Skull Games</title>
        <meta
          name="description"
          content="Learn how returns, cancellations, and refunds are handled for Rogue Skull Games orders printed on demand by TheGameCrafter."
        />
        <link rel="canonical" href="https://rogueskullgames.com/return-policy" />
        <meta property="og:title" content="Return Policy | Rogue Skull Games" />
        <meta
          property="og:description"
          content="How returns, cancellations, and refunds work for orders printed on demand by TheGameCrafter."
        />
        <meta property="og:url" content="https://rogueskullgames.com/return-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <main className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="relative z-10 pt-[220px] pb-20">
          <PointedSectionBackground />
          <div className="container relative z-10 mx-auto px-4 text-center">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-dark-foreground mb-6">{title}</h1>
            <p className="text-lg text-dark-foreground/70 max-w-2xl mx-auto">{subtitle}</p>
          </div>
        </section>

        {/* Content Section */}
        <section className="pt-32 pb-16 md:pt-36 md:pb-24">
          <div className="container mx-auto px-4 max-w-3xl">
            <div
              className="return-policy-content prose prose-lg max-w-none text-[hsl(0,0%,35%)]
                [&_h2]:font-heading [&_h2]:text-2xl md:[&_h2]:text-3xl [&_h2]:text-[hsl(0,0%,10%)] [&_h2]:mb-6
                [&_h3]:font-heading [&_h3]:text-xl [&_h3]:text-[hsl(0,0%,10%)] [&_h3]:mb-4
                [&_p]:mb-8 [&_p]:leading-relaxed
                [&_ul]:mb-8 [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-2
                [&_ol]:mb-8 [&_ol]:list-decimal [&_ol]:list-inside [&_ol]:space-y-2
                [&_hr]:mt-14 [&_hr]:mb-12 [&_hr]:border-[hsl(0,0%,85%)]
                [&_strong]:text-[hsl(0,0%,10%)]
                [&_a]:text-blood-red hover:[&_a]:underline"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            />
          </div>
        </section>
      </main>
    </MainLayout>
  );
};

export default ReturnPolicy;
